export const SELECT_ELEMENT = 'SELECT_ELEMENT';
export const SELECT_ELEMENTS = 'SELECT_ELEMENTS';
export const UNSELECT_ELEMENT = 'UNSELECT_ELEMENT';
export const UNSELECT_ALL = 'UNSELECT_ALL';
export const UNSELECT_EDGE = 'UNSELECT_EDGE';
export const UNSELECT_EDGES = 'UNSELECT_EDGES';
export const RESET_ALL_EDGES = 'RESET_ALL_EDGES';
export const RESET_EDGE = 'RESET_EDGE';
export const ADD_FILTER = 'ADD_FILTER';
export const ADD_FILTERS = 'ADD_FILTERS';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';
export const OPEN_SPOTLIGHT = 'OPEN_SPOTLIGHT';
export const CLOSE_SPOTLIGHT = 'CLOSE_SPOTLIGHT';
export const TEASER_SHOWN = 'TEASER_SHOWN';
export const TRIGGER_COMMERCIAL = 'TRIGGER_COMMERCIAL';
export const TRIGGER_FORMATS = 'TRIGGER_FORMATS';

class Actions {
    selectElements(elements) {
        return {
            type: SELECT_ELEMENTS,
            elements: elements
        }
    }

    selectElement(elementId, categoryId) {
        return {
            type: SELECT_ELEMENT,
            element: {
                id: elementId,
                category: categoryId
            }
        }
    }

    unselectElement(elementId, categoryId) {
        return {
            type: UNSELECT_ELEMENT,
            element: {
                id: elementId,
                category: categoryId
            }
        }
    }

    unselectAll() {
        return {
            type: UNSELECT_ALL
        }
    }

    unselectEdge(edgeId) {
        return {
            type: UNSELECT_EDGE,
            edgeId: edgeId
        }
    }

    unselectEdges(edgeIds) {
        return {
            type: UNSELECT_EDGES,
            edgeIds: edgeIds
        }
    }

    resetAllEdges() {
        return {
            type: RESET_ALL_EDGES
        }
    }

    resetEdge(edgeId) {
        return {
            type: RESET_EDGE,
            edgeId: edgeId
        }
    }

    addFilter(filter) {
        return {
            type: ADD_FILTER,
            filter: filter
        }
    }

    addFilters(filters) {
        return {
            type: ADD_FILTERS,
            filters: filters
        }
    }

    removeFilter(filter) {
        return {
            type: REMOVE_FILTER,
            filter: filter
        }
    }

    resetFilters() {
        return {
            type: RESET_FILTERS
        }
    }

    openSpotlight() {
        return {
            type: OPEN_SPOTLIGHT
        }
    }

    closeSpotlight() {
        return {
            type: CLOSE_SPOTLIGHT
        }
    }

    teaserShown(teaserId){
        return {
            type: TEASER_SHOWN,
            teaserId: teaserId
        }
    }

    triggerCommercial(){
        return {
            type: TRIGGER_COMMERCIAL
        }
    }

    triggerFormats(){
        return {
            type: TRIGGER_FORMATS
        }
    }
}

export const actions = new Actions();


// WEBPACK FOOTER //
// ./src/redux/actions/index.js